export default {

    /** 郵便番号CSVインポート **/
    setImportPostalCsvStatus (state, status) {
        state.importPostalCsvStatus = status
    },

    /** システムメールグループ名称リスト**/
    setSysMailInfo (state, resp) {
        state.sysMailInfo = resp
    },
    setSysMailInfoLoadStatus (state, status) {
        state.sysMailInfoLoadStatus = status
    },

    /** システムメールグループ名・ステータス修正　**/
    setMailGroupEditSaveStatus (state, status) {
        state.mailGroupEditSaveStatus = status
    },
    updateMailGroupEdit (state, data) {
        if (data.groupNmChanged) {
            let new_group_nm = data.groupNm
            let group_id = data.groupId
            let list = 'mail_group_info_' + data.groupType
            let idx = state.sysMailInfo.data[list].findIndex((item)=>item.mail_group_id == group_id)
            if (idx != -1) {
                let obj = state.sysMailInfo.data[list][idx]
                obj.mail_group_nm = new_group_nm
            }
        }
    },

    /** システムメールグループ削除　**/
    setMailGroupEditDelStatus (state, status) {
        state.mailGroupEditDelStatus = status
    },

    /** システムメール送信グループ **/
    setMailGroupMember (state, resp) {
        state.mailGroupMember = resp
    },
    setMailGroupMemberSelected (state, data) {
        state.mailGroupMemberSelected = data
    },
    resetMailGroupMemberSelected (state) {
        state.mailGroupMemberSelected = []
    },
    setMailGroupMemberLoadStatus (state, status) {
        state.mailGroupMemberLoadStatus = status
    },
    resetMailGroupMember (state) {
        state.mailGroupMember = {}
        state.mailGroupMemberLoadStatus = 0
    },
    setChangeMailGroupStatus (state, status) {
        state.changeMailGroupStatus = status
    },
    updateMailGroupList (state, data) {
        if (data.new_group_list) {
            state.mailGroupMember.data.group_list = data.new_group_list
        }
    },
    updateMailGroupMemberToList (state, data) {
        let id = data.new_member.id
        let idx = state.mailGroupMember.data.group_members.findIndex((item)=>item.id == id)
        if (idx != -1) {
            let obj = state.mailGroupMember.data.group_members[idx]
            let combin = Object.assign({}, obj, data.new_member)
            state.mailGroupMember.data.group_members.splice(idx, 1, combin)
        }
    },
    updateMailGroupMemberToSelectList (state, data) {
        let id = data.new_member.id
        let idx = state.mailGroupMemberSelected.findIndex((item)=>item.id == id)
        if (idx != -1) {
            let obj = state.mailGroupMemberSelected[idx]
            let combin = Object.assign({}, obj, data.new_member)
            state.mailGroupMemberSelected.splice(idx, 1, combin)
        }
    },

    /** システムメールテンプレート保存　**/

    setMailTempSave (state, data) {
        state.mailTempSave = data
    },
    setMailTempSaveStatus (state, status) {
        state.mailTempSaveStatus = status
    },
    setMailTempDelStatus (state, status) {
        state.mailTempDelStatus = status
    },
    setSysMailSendStatus (state, status) {
        state.sysMailSendStatus = status
    },
    setSysMailSendCnt (state, data) {
        state.sysMailSendCnt = data
    },
    updateMailTempList (state, data) {
        let idx = state.sysMailInfo.data.mail_temp_info.findIndex((item)=>item.id == data.id)
        if (idx == -1) {
            state.sysMailInfo.data.mail_temp_info.push(data)
        } else {
            state.sysMailInfo.data.mail_temp_info.splice(idx, 1, data)
        }
    },
    delMailTempFromList (state, data) {
        let idx = state.sysMailInfo.data.mail_temp_info.findIndex((item)=>item.id == data.id)
        if (idx != -1) {
            state.sysMailInfo.data.mail_temp_info.splice(idx, 1)
        }
    }
    
}
